import styled from 'styled-components'

export const AllBannerWrapper = styled.div`
	display: flex;
	flex-wrap: wrap;
	/* margin: 0 var(--mg-sm); */
	margin-top: 15px;
	justify-content: center;
	width: 100%;
`

export const BannerWrapper = styled.div<{ customStyle: boolean | undefined }>`
	border-radius: var(--border-radius-sm);
	padding: car(--pd-xs);
	display: flex;
	justify-content: space-between;
	flex-wrap: wrap;
	/* margin-top: var(--mg-sm); */
	/* position: sticky; */
	bottom: ${(props) => (props.customStyle ? -25 + 'px' : -5 + 'px')};
`

export const OfferDetailDiv = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	margin: var(--mg-sm);
`

export const BannerImage = styled.img`
	width: 100%;
`
